export class IndividualAgeGroupReferenceModel {
    public individualAgeGroupCode: string;
    public parentIndividualAgeGroupCode: string;
    public individualAgeGroupName: string;
    public masterFlag: boolean;
    public conditionCode: string;
    public ageYearValue: number;
    public sortSequence: number;
}